import { useQuery } from '@tanstack/react-query';

import { getUserDocuments } from '@arrived/api_v2';
import { UserDocument, UserId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { userDocumentsKeyFn } from './userDocuments.keys';

export function useUserDocumentsQuery(userId?: UserId, options?: UseQueryOptions<UserDocument[]>) {
  return useQuery(userDocumentsKeyFn(userId!), async () => getUserDocuments(userId!), {
    ...options,
    enabled: (options?.enabled ?? true) && userId != null,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
